import React, { Component } from "react";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Input, Tooltip } from "@revvsales/components";
import ClauseForm from "./ClauseForm";
import SingleLineTextFieldFormMode from "./FormModeComponents/SingleLineTextFormMode";
import EmailTextFieldFormMode from "./FormModeComponents/EmailTextFormMode";
import URLFieldFormMode from "./FormModeComponents/UrlFieldFormMode";
import PhoneFieldFormMode from "./FormModeComponents/PhoneFieldFormMode";
import PercentFieldFormMode from "./FormModeComponents/PercentFieldFormMode";
import AmountFieldFormMode from "./FormModeComponents/AmountFieldFormMode";
import NumberFieldFormMode from "./FormModeComponents/NumberFieldFormMode";
import MultiLineTextFieldFormMode from "./FormModeComponents/MultiLineFieldFormMode";
import CommonSelectFieldFormMode from "./FormModeComponents/CommonSelectFieldFormMode";
import DateFieldFormMode from "./FormModeComponents/DateFieldFormMode";
import PersonNameFormMode from "./FormModeComponents/PersonNameFormMode";
import PeriodFormMode from "./FormModeComponents/PeriodFormMode";
import RateFormMode from "./FormModeComponents/RateFormMode";
import AddressFormMode from "./FormModeComponents/AddressFormMode";
import RadioFieldFormMode from "./FormModeComponents/RadioFormMode";
import CheckboxFormMode from "./FormModeComponents/CheckboxFormMode";
import ImageFormField from "./FormModeComponents/ImageFormField";

import {
  updateFormRowDataField,
  updateDynamicFieldsInDoc,
  updateClauseOptionsinDoc,
} from "../../../actions/DocumentActions/index";

import { GlobalUtils } from "../../../utils";

const { readDataFromLocalStorage } = GlobalUtils;

const getOffsetTop = element => {
  let offsetTop = 0;
  while (element) {
    offsetTop += element.offsetTop;
    element = element.offsetParent;
  }
  return offsetTop;
};

class FormModeField extends Component {
  inputRef = React.createRef();

  state = {
    formValue: null,
    display: false,
    status: false,
    screen: "desktop",
    assignRecepient: this.props.filler_type === "RECIPIENT",
    assignRecepientLoader: false,
    disableAssignReceipent: false,
  };

  componentDidMount() {
    const { value, type } = this.props;
    this._checkFilled(value, type);
    if (window.innerWidth < 600) {
      this.setState({ status: true, screen: "mobile" });
    }
  }

  componentDidUpdate() {
    if (
      this.props.id !== this.props.currentOpenField &&
      this.state.status &&
      this.state.screen !== "mobile"
    ) {
      // eslint-disable-next-line react/no-did-update-set-state
      this.setState({ status: false });
    }
  }

  _handleOnClose = e => {
    e.stopPropagation();
  };

  _checkFilled = (value, type) => {
    let flag = false;
    if (value && typeof value !== "string" && typeof value !== "number") {
      const vals = Object.values(value);
      flag = !!vals.length;
      if (flag) {
        flag = !vals.includes("");
        if (type === "ADDRESS") {
          let count = 0;
          for (let i = 0; i < vals.length; i += 1) {
            if (vals[i]) {
              count += 1;
            }
          }
          if ((!vals.addressLineTwo || !vals.addressLineTwo) && count >= 4) {
            flag = true;
            this.setState({ display: flag });
          }
        }
        if (type === "PERSON_NAME") {
          flag = !!vals[0] || !!vals[1];
        }
      }
    }
    if (typeof value === "string" || typeof value === "number") {
      if (value) {
        flag = true;
        this.setState({ display: flag });
      }
    }
    if (flag) {
      this.props.handleCompletedCount(flag);
      this.setState({ display: flag });
    }
    return flag;
  };

  _getFieldInView = val => {
    if (val) {
      setTimeout(() => {
        const formFieldEle = document.getElementById(this.props.id);
        if (formFieldEle) {
          formFieldEle.scrollIntoView({ behavior: "smooth" });
        }
      }, 300);
    }
  };

  _handleChange = (val, _, event) => {
    const inputRefVal = this.inputRef ? this.inputRef.current : null;
    if (inputRefVal && inputRefVal.contains(event.target)) {
      return;
    }
    if (this.state.screen === "desktop") {
      this.setState({ status: val }, () => this._getFieldInView(val));
      if (val) {
        this.props.setCurrentField(this.props.id);
        let getEleId = null;
        if (this.props.type === "IMAGE") {
          getEleId = `image_field_${this.props.id}`;
        } else {
          getEleId = this.props.occurrences[0].occurenceId;
        }
        const occurEle = getEleId ? document.getElementById(getEleId) : null;
        const docEle = document.getElementById("document-sections-wrapper");
        let scrollToEle = null;
        if (this.state.display) {
          if (this.props.type === "IMAGE") {
            scrollToEle = "scrolled-image-field-completed";
          } else {
            scrollToEle = "scrolled-df-completed";
          }
        } else if (this.props.type === "IMAGE") {
          scrollToEle = "scrolled-image-field";
        } else {
          scrollToEle = "scrolled-df";
        }

        if (occurEle && docEle) {
          // extra 200px needed to bring ele in view
          docEle.scrollTop = getOffsetTop(occurEle) - 200;
          // occurEle.scrollIntoView({ behavior: "smooth", block: "center" });
          occurEle.classList.add(scrollToEle);
          setTimeout(() => {
            occurEle.classList.remove(scrollToEle);
          }, 3000);
        }
      }
    }
  };

  _setToggleCheckbox = (id, value) => {
    const { assignRecepient } = this.state;
    this.setState({
      assignRecepient: !assignRecepient,
      assignRecepientLoader: true,
    });
    let fillerType = "SENDER";
    if (!assignRecepient) {
      fillerType = "RECIPIENT";
    }
    this.props
      .updateDynamicFieldsInDoc(id, value, false, null, fillerType)
      .then(() => {
        this.setState({ assignRecepientLoader: false });
      })
      .catch(err =>
        console.error(`FormModeField => _setToggleCheckbox => Err: ${err}`),
      );
  };

  _updateField = (id, value, compositeFieldKeyName) => {
    this.props.updateFormRowDataField(id, value, compositeFieldKeyName);
  };

  _handleAssignRecepientOnBlur = (id, value) => {
    const { assignRecepient } = this.state;
    console.debug("assignRecepient", assignRecepient);
    let fillerType = "SENDER";
    if (assignRecepient) {
      fillerType = "RECIPIENT";
      this.setState({ assignRecepient: true });
    } else {
      this.setState({ assignRecepient: false });
    }
    this.props.updateDynamicFieldsInDoc(id, value, false, null, fillerType);
  };

  _updateDynamicFieldsInDoc = (id, value) =>
    new Promise((resolve, reject) => {
      const { sharingHash } = this.props.match.params;
      const fillerType = this.props.filler_type;
      // let fillerType = "SIGNER";
      // console.log("state,", this.state.assignRecepient);
      // if (this.state.assignRecepient) {
      //   fillerType = "RECIPIENT";
      // }
      if (sharingHash) {
        this.props
          .updateDynamicFieldsInDoc(id, value, true, sharingHash, fillerType)
          .then(r => {
            resolve(r);
          })
          .catch(e => {
            reject(e);
          });
      } else
        this.props
          .updateDynamicFieldsInDoc(id, value, false, null, fillerType)
          .then(r => {
            resolve(r);
          })
          .catch(e => {
            reject(e);
          });
    });

  _updateFilledStatus = val => {
    if (!this.state.display && val) {
      this.props.handleCompletedCount(val);
    }
    if (this.state.display && !val) {
      this.props.handleCompletedCount(val);
    }
    this.setState({ display: val });
  };

  _updateFormValue = value => {
    this.setState({ formValue: value });
  };

  _updateClauseField = updatedValue => {
    const { id } = this.props;
    this._updateDynamicFieldsInDoc(id, updatedValue);
  };

  _renderField = (type, fillerType) => {
    const CURRENT_USER = readDataFromLocalStorage("revvsalesUser");
    let OwnerFiller = false;
    const OwnerFillerCheck =
      this.props.stage === "SENT_FOR_FILLING" &&
      this.props.docRecipientList &&
      this.props.docRecipientList.some(
        item =>
          item.user &&
          item.user.id === CURRENT_USER.id &&
          item.recipient_type === "FILLER",
      );
    if (OwnerFillerCheck && fillerType !== "RECIPIENT") {
      OwnerFiller = true;
    }
    const { value, meta, docIsLocked } = this.props;
    const { formValue } = this.state;
    switch (type) {
      case "SINGLE_LINE_TEXT":
        return (
          <SingleLineTextFieldFormMode
            isLocked={docIsLocked || OwnerFiller}
            initialProps={this.props}
            _updateField={this._updateField}
            _updateDynamicFieldsInDoc={this._updateDynamicFieldsInDoc}
            filledStatus={this._updateFilledStatus}
          />
        );
      case "EMAIL":
        return (
          <EmailTextFieldFormMode
            isLocked={docIsLocked || OwnerFiller}
            initialProps={this.props}
            _updateField={this._updateField}
            _updateDynamicFieldsInDoc={this._updateDynamicFieldsInDoc}
            filledStatus={this._updateFilledStatus}
          />
        );
      case "URL":
        return (
          <URLFieldFormMode
            isLocked={docIsLocked || OwnerFiller}
            initialProps={this.props}
            _updateField={this._updateField}
            _updateDynamicFieldsInDoc={this._updateDynamicFieldsInDoc}
            filledStatus={this._updateFilledStatus}
          />
        );
      case "PHONE":
        return (
          <PhoneFieldFormMode
            isLocked={docIsLocked || OwnerFiller}
            initialProps={this.props}
            _updateField={this._updateField}
            _updateDynamicFieldsInDoc={this._updateDynamicFieldsInDoc}
            filledStatus={this._updateFilledStatus}
          />
        );
      case "PERCENT":
        return (
          <PercentFieldFormMode
            isLocked={docIsLocked || OwnerFiller}
            initialProps={this.props}
            _updateField={this._updateField}
            _updateDynamicFieldsInDoc={this._updateDynamicFieldsInDoc}
            filledStatus={this._updateFilledStatus}
          />
        );
      case "AMOUNT":
        return (
          <AmountFieldFormMode
            isLocked={docIsLocked || OwnerFiller}
            initialProps={this.props}
            _updateField={this._updateField}
            _updateDynamicFieldsInDoc={this._updateDynamicFieldsInDoc}
            filledStatus={this._updateFilledStatus}
          />
        );
      case "NUMBER":
        return (
          <NumberFieldFormMode
            isLocked={docIsLocked || OwnerFiller}
            initialProps={this.props}
            _updateField={this._updateField}
            _updateDynamicFieldsInDoc={this._updateDynamicFieldsInDoc}
            filledStatus={this._updateFilledStatus}
          />
        );
      case "MULTI_LINE_TEXT":
        return (
          <MultiLineTextFieldFormMode
            isLocked={docIsLocked || OwnerFiller}
            initialProps={this.props}
            _updateField={this._updateField}
            _updateDynamicFieldsInDoc={this._updateDynamicFieldsInDoc}
            filledStatus={this._updateFilledStatus}
          />
        );

      case "COUNTRY":
      case "US_STATES":
      case "SINGLE_SELECT":
        return (
          <CommonSelectFieldFormMode
            isLocked={docIsLocked || OwnerFiller}
            initialProps={this.props}
            _updateField={this._updateField}
            _updateDynamicFieldsInDoc={this._updateDynamicFieldsInDoc}
            filledStatus={this._updateFilledStatus}
          />
        );
      case "DATE":
        return (
          <DateFieldFormMode
            isLocked={docIsLocked || OwnerFiller}
            initialProps={this.props}
            _updateField={this._updateField}
            _updateDynamicFieldsInDoc={this._updateDynamicFieldsInDoc}
            filledStatus={this._updateFilledStatus}
          />
        );
      case "PERSON_NAME":
        return (
          <PersonNameFormMode
            isLocked={docIsLocked || OwnerFiller}
            initialProps={this.props}
            _updateField={this._updateField}
            _updateDynamicFieldsInDoc={this._updateDynamicFieldsInDoc}
            filledStatus={this._updateFilledStatus}
          />
        );
      case "PERIOD":
        return (
          <PeriodFormMode
            isLocked={docIsLocked || OwnerFiller}
            initialProps={this.props}
            _updateField={this._updateField}
            _updateDynamicFieldsInDoc={this._updateDynamicFieldsInDoc}
            filledStatus={this._updateFilledStatus}
          />
        );
      case "RATE":
        return (
          <RateFormMode
            isLocked={docIsLocked || OwnerFiller}
            initialProps={this.props}
            _updateField={this._updateField}
            _updateDynamicFieldsInDoc={this._updateDynamicFieldsInDoc}
            filledStatus={this._updateFilledStatus}
          />
        );
      case "ADDRESS":
        return (
          <AddressFormMode
            isLocked={docIsLocked || OwnerFiller}
            initialProps={this.props}
            _updateField={this._updateField}
            _updateDynamicFieldsInDoc={this._updateDynamicFieldsInDoc}
            filledStatus={this._updateFilledStatus}
          />
        );
      case "RADIO":
        return (
          <RadioFieldFormMode
            isLocked={docIsLocked || OwnerFiller}
            initialProps={this.props}
            _updateField={this._updateField}
            _updateDynamicFieldsInDoc={this._updateDynamicFieldsInDoc}
            filledStatus={this._updateFilledStatus}
          />
        );

      case "CHECKBOX":
        return (
          <CheckboxFormMode
            isLocked={docIsLocked || OwnerFiller}
            initialProps={this.props}
            _updateField={this._updateField}
            _updateDynamicFieldsInDoc={this._updateDynamicFieldsInDoc}
            filledStatus={this._updateFilledStatus}
          />
        );
      case "CLAUSE":
        return (
          <ClauseForm
            meta={meta}
            value={value}
            formValue={formValue}
            docIsLocked={docIsLocked || OwnerFiller}
            updateFormValue={this._updateFormValue}
            updateClauseFieldValue={this._updateClauseField}
            filledStatus={this._updateFilledStatus}
          />
        );
      case "IMAGE":
        return (
          <ImageFormField
            isLocked={docIsLocked}
            docIsLocked={this.props.docIsLocked || OwnerFiller}
            id={this.props.id}
            label={this.props.label}
            description={this.props.description}
            value={this.props.value}
            updateField={this._updateField}
            updateDynamicFieldsInDoc={this._updateDynamicFieldsInDoc}
            filledStatus={this._updateFilledStatus}
            sharingHash={this.props.sharingHash}
            isSharedDocument={this.props.isSharedDocument}
            docID={this.props.docID}
            metaData={this.props.meta}
            imageSecitonId={
              this.props.occurrences &&
              this.props.occurrences.length > 0 &&
              this.props.occurrences[0]
                ? this.props.occurrences[0].componentId
                : null
            }
          />
        );
      default:
        return <p>No field</p>;
    }
  };

  _sharedDocView = () => {
    const { id, label, description, type, occurrences, value } = this.props;
    let formIcon = "";
    if (!this.state.display) {
      formIcon = <FontAwesomeIcon icon={["fas", "circle"]} color="#FFDD4D" />;
    } else {
      formIcon = (
        <FontAwesomeIcon icon={["fas", "check-circle"]} color="green" />
      );
    }
    return !this.state.status ? (
      <div
        role="button"
        tabIndex="0"
        onClick={event => this._handleChange(!this.state.status, value, event)}
        onKeyUp={() => {}}
        data-test={`form-field-${label}`}
        className={`form-mode-field ${!this.state.status ? "closed" : "open"}`}>
        <div className="form-mode-field-title-wrapper" id={id}>
          <div className="form-title-left">
            <div className="form-status-icon">{formIcon}</div>
            <div className="form-mode-field-title">{`${label}`}</div>
          </div>
          {occurrences.length > 1 && (
            <div className="form-mode-instances">x {occurrences.length}</div>
          )}
        </div>
      </div>
    ) : (
      <div
        role="button"
        tabIndex="0"
        onClick={event => this._handleChange(!this.state.status, value, event)}
        onKeyUp={() => {}}
        className={`form-mode-field open ${
          this.state.display ? "completed" : ""
        }`}
        id={id}>
        <div className="form-mode-field-title-wrapper">
          <div className="form-mode-field-title">{`${label}`}</div>
          {occurrences.length > 1 && (
            <div className="form-mode-instances">
              {`x ${occurrences.length}`}
            </div>
          )}
        </div>
        <div className="form-mode-field-subtitle">{description}</div>
        <div
          role="button"
          tabIndex="0"
          onClick={e => this._handleOnClose(e)}
          onKeyUp={() => {}}
          className="form-mode-field-container">
          {this._renderField(type)}
        </div>
      </div>
    );
  };

  render() {
    const { sharingHash } = this.props.match.params;
    const { id, label, description, type, occurrences, value } = this.props;
    let formIcon = "";
    if (this.props.filler_type === "RECIPIENT") {
      formIcon = (
        <FontAwesomeIcon icon={["fas", "user-circle"]} color="#888888" />
      );
    } else if (!this.state.display) {
      formIcon = <FontAwesomeIcon icon={["fas", "circle"]} color="#FFDD4D" />;
    } else {
      formIcon = (
        <FontAwesomeIcon icon={["fas", "check-circle"]} color="green" />
      );
    }
    // eslint-disable-next-line no-nested-ternary
    return sharingHash === undefined &&
      this.props.recipientType !== "FILLER" ? (
      !this.state.status ? (
        <div
          role="button"
          tabIndex="0"
          onClick={event =>
            this._handleChange(!this.state.status, value, event)
          }
          onKeyUp={() => {}}
          data-test={`form-field-${label}`}
          className={`form-mode-field ${
            !this.state.status ? "closed" : "open"
          }`}>
          <div className="form-mode-field-title-wrapper" id={id}>
            <div className="form-title-left">
              <div className="form-status-icon">{formIcon}</div>
              <div className="form-mode-field-title">{`${label}`}</div>
            </div>
            {occurrences.length > 1 && (
              <div className="form-mode-instances">x {occurrences.length}</div>
            )}
          </div>
        </div>
      ) : (
        <div
          role="button"
          tabIndex="0"
          onClick={event =>
            this._handleChange(!this.state.status, value, event)
          }
          onKeyUp={() => {}}
          className={`form-mode-field open ${
            this.state.display ? "completed" : ""
          }`}
          id={id}
          ref={this.inputRef}>
          <div className="form-mode-field-title-wrapper">
            <div className="form-mode-field-title">{`${label}`}</div>
            {occurrences.length > 1 && (
              <div className="form-mode-instances">
                {`x ${occurrences.length}`}
              </div>
            )}
          </div>
          <div className="form-mode-field-subtitle">{description}</div>
          <div
            role="button"
            tabIndex="0"
            onClick={e => this._handleOnClose(e)}
            onKeyUp={() => {}}
            className="form-mode-field-container">
            {this._renderField(type, this.props.filler_type)}
          </div>
          {!this.props.docIsLocked && this.props.stage === "DRAFT" ? (
            <div
              id="assign-recipent-filler"
              className="form-mode-field-subtitle assign-recipent-filler">
              <Input
                disabled={
                  this.state.disableAssignReceipent ||
                  this.state.assignRecepientLoader
                }
                data-test="add-recepient-as-filler"
                type="checkbox"
                checked={this.props.filler_type === "RECIPIENT"}
                onChange={() =>
                  this._setToggleCheckbox(this.props.id, this.props.value)
                }
              />
              <span className="assign-recepient-checkbox-lable">
                Assign to recipient
                <Tooltip
                  placement="bottom"
                  align={{
                    offset: [0, 4],
                  }}
                  overlay="Check this box to allow recipients to fill this field when you send documents for eSign">
                  <FontAwesomeIcon
                    className="assign-recepient-info-icon"
                    icon={["far", "info-circle"]}
                  />
                </Tooltip>
              </span>
              {this.state.assignRecepientLoader && (
                <span className="assign-recipent-loader">Saving ...</span>
              )}
            </div>
          ) : null}
        </div>
      )
    ) : // eslint-disable-next-line no-nested-ternary
    this.props.filler_type === "RECIPIENT" &&
      (this.props.recipientType === "FILLER" ||
        this.props.recipientType === "SIGNER") ? (
      this._sharedDocView()
    ) : this.props.recipientType === "ACCEPTOR" ||
      this.props.recipientType === "REVIEWER" ? (
      this._sharedDocView()
    ) : null;
  }
}

const mapStateToProps = state => {
  const {
    document: { scope: { write, fill } = {}, isLocked, stage } = {},
    docForm,
    docRecipientList,
  } = state.DocumentStore;
  const { recipientType } = state.SharedDocument;
  const CURRENT_USER = readDataFromLocalStorage("revvsalesUser");
  // For internal user
  const currentUserIsFiller = docRecipientList.some(
    item =>
      item.user &&
      item.user.id === CURRENT_USER.id &&
      item.recipient_type === "FILLER",
  );

  let lockedInStage = true;
  if (
    stage === "DRAFT" ||
    (stage === "SENT_FOR_FILLING" &&
      (recipientType === "FILLER" || currentUserIsFiller))
  ) {
    lockedInStage = false;
  }
  return {
    recipientType,
    stage,
    docIsLocked: (isLocked && !(write || fill)) || lockedInStage,
    docForm,
    docRecipientList,
  };
};

const mapDispatchToProps = {
  updateFormRowDataField,
  updateDynamicFieldsInDoc,
  updateClauseOptionsinDoc,
};

export default withRouter(
  connect(
    mapStateToProps,
    mapDispatchToProps,
  )(FormModeField),
);



// WEBPACK FOOTER //
// ./src/components/DocumentV2/FormView/FormModeField.js